import Vue from 'vue';
import { Button, Image } from 'vant';
import App from './App.vue';
import router from './router';
import store from './store';
// 过滤器
import './mixin/filter';
import hideOptionMenu from './mixin/hideOptionMenu';
// require styles
import './style/index.less';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

// 常用函数
import knife from './vendor/knife';
Vue.prototype.$knife = knife;

import { Col, Row, Popup, Toast } from 'vant';
Vue.use(Popup);
Vue.use(Col);
Vue.use(Row);
Vue.use(Toast);
Vue.use(Button);
Vue.use(Image);
Vue.prototype.$toast = (message, duration = 1500) => Toast({ message, duration });
Vue.prototype.$indicator = {
  open(message) {
    Toast.loading({
      message,
      forbidClick: true,
      duration: 0,
    });
  },
  close: Toast.clear,
};

import VueQuillEditor from 'vue-quill-editor';
Vue.use(VueQuillEditor);

// import html2canvas from "html2canvas";
// Vue.use(html2canvas);

// 阻止显示生产模式的消息
Vue.config.productionTip = false;

// 根据地址栏参数名称获取对应的值
window.getQueryString = (name) => {
  // const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  // 检索文本内容并存储
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  // 获取url中"?"符后的字符串并正则匹配
  const r = window.location.search.substr(1).match(reg);
  // decodeURIComponent解决url传递参数中文乱码的问题
  if (r != null) return decodeURIComponent(r[2]);
  return '';
};

new Vue({
  mixins: [hideOptionMenu],
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
